import * as React from 'react'

import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
} from 'react-router'

import {
  RegistrationCoach,
  RegistrationCoachee,
  RegistrationCompanyCoaching,
  RegistrationCompanyMentoring,
  RegistrationMentee,
  RegistrationMentor,
} from '../../routing/Registrations'

export default ({ match }: RouteComponentProps<{}>) => (
  <Switch>
    <Route
      path={match.url + '/mentee/:token'}
      component={RegistrationMentee}
    />
    <Route
      path={match.url + '/mentor/:token'}
      component={RegistrationMentor}
    />
    <Route
      path={match.url + '/company-mentoring/:token'}
      component={RegistrationCompanyMentoring}
    />
    <Route
      path={match.url + '/coachee/:token'}
      component={RegistrationCoachee}
    />
    <Route
      path={match.url + '/coach/:token'}
      component={RegistrationCoach}
    />
    <Route
      path={match.url + '/company-coaching/:token'}
      component={RegistrationCompanyCoaching}
    />
    <Route component={() => <Redirect to={'/'} />} />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/components/environments/RegisterArea.tsx